
import {
  Avatar,
  FormControl,
  InputLabel,
  ListItem,
  ListItemAvatar,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import React from "react";
import { PersonOption } from "../../types/AssignPerson.types";

interface PersonSelectProps {
  value: number | null;
  onChange: (value: number | null) => void;
  persons: PersonOption[];
  label: string;
  disabled?: boolean;
  allowClear?: boolean;
  clearLabel?: string;
}

const PersonSelect: React.FC<PersonSelectProps> = ({
  value,
  onChange,
  persons,
  label,
  disabled = false,
  allowClear = false,
  clearLabel = "Ingen tilldelning",
}) => {
  const handleChange = (event: SelectChangeEvent<number | string>) => {
    const val = event.target.value;
    onChange(val === "" ? null : Number(val));
  };

  return (
    <FormControl fullWidth margin="normal" disabled={disabled}>
      <InputLabel id="person-select-label">{label}</InputLabel>
      <Select
        labelId="person-select-label"
        id="person-select"
        value={value ?? ""}
        label={label}
        onChange={handleChange}
      >
        {allowClear && (
          <MenuItem value="">
            <em>{clearLabel}</em>
          </MenuItem>
        )}
        {persons.map((person) => (
          <MenuItem key={person.id} value={person.id}>
            <ListItem disableGutters disablePadding>
              <ListItemAvatar>
                <Avatar src={person.avatar}>
                  {person.name[0]?.toUpperCase()}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={person.name}
                secondary={person.title || person.email || ""}
              />
            </ListItem>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PersonSelect;
